import React, { Component } from "react";

class UpcomingSection extends Component {
  render() {
    const { apps, language, t } = this.props;

    if (!apps || apps.length === 0) {
      return null;
    }

    return (
      <section className="section section-alt" id="upcoming">
        <div className="section-inner">
          <div className="section-head">
            <h2>{t("sections.upcomingTitle")}</h2>
            <p>{t("sections.upcomingDesc")}</p>
          </div>
          <div className="upcoming-grid">
            {apps.map((app, index) => (
              <article className="upcoming-card" key={app.name}>
                <div className="upcoming-logo">
                  <img src={app.logoPath} alt={`${app.name} logo`} />
                </div>
                <div className="upcoming-head">
                  <h3>{app.name}</h3>
                  <span>{app.window}</span>
                </div>
                <p>{(app.focus && app.focus[language]) || app.focus}</p>
                <button className="ghost-btn">{t("sections.upcomingCta")}</button>
              </article>
            ))}
          </div>
        </div>
      </section>
    );
  }
}

export default UpcomingSection;
